import { classNames, Tooltip } from '@ui-components-3/ui'
import { OperatingHoursBarSegment } from 'hooks/operating-hours/types'
import { formatTimeToNearestFiveMinutes } from 'hooks/operating-hours/utils'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

type WeekDayBarSegmentProps = {
  segment: OperatingHoursBarSegment
}

const WeekDayBarSegment = ({ segment }: WeekDayBarSegmentProps) => {
  const { t } = useTranslation()
  const { isAvailable, widthPercentage, leftPositionPercentage, startsAt, endsAt } = segment || {}

  const availabilityLabel = t(`operatingHours.modal.${isAvailable ? 'available' : 'unavailable'}`)

  const tooltipContent = useMemo(() => {
    const startTime = formatTimeToNearestFiveMinutes(startsAt)
    const endTime = formatTimeToNearestFiveMinutes(endsAt)

    return `${availabilityLabel}\n${[startTime, endTime].filter(Boolean).join(' - ')}`
  }, [availabilityLabel, endsAt, startsAt])

  if (!segment && leftPositionPercentage >= 100) return null

  return (
    <Tooltip
      content={<div className="whitespace-pre-line text-center">{tooltipContent}</div>}
      placement="top"
      variant="dark"
      contentOffset="s"
      showArrow
    >
      <div
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={0}
        aria-label={availabilityLabel}
        className={classNames('absolute top-0 h-full', isAvailable ? 'bg-secondary-600' : 'bg-neutral-300')}
        style={{ width: `${widthPercentage}%`, left: `${leftPositionPercentage}%` }}
      />
    </Tooltip>
  )
}

export default WeekDayBarSegment
